import { Image } from './Image';
import { CdnObjectType, SymbolType } from '@/types';
import { useAssetCdn } from '@/context/Ui';

interface CdnMediaProps {
  className?: string;
  symbol: string;
  symbolType: SymbolType;
  objectType: CdnObjectType;
  isExemplar?: boolean;
  width: number;
  height: number;
}

export const CdnMedia = ({
  className,
  symbol,
  symbolType,
  objectType,
  isExemplar = false,
  width,
  height,
}: CdnMediaProps) => {
  const mediaUrl = useAssetCdn(symbol, symbolType, objectType, isExemplar);

  const renderMedia = (url: string) => {
    switch (objectType) {
      case CdnObjectType.Image:
        return (
          <Image
            className={className}
            src={url}
            alt={''}
            width={width}
            height={height}
          />
        );
    }
  };

  return Array.isArray(mediaUrl) && mediaUrl.length ? (
    mediaUrl.map((url) => renderMedia(url))
  ) : !!mediaUrl && mediaUrl !== '' ? (
    renderMedia(mediaUrl as string)
  ) : (
    <p>
      No {objectType} media found for {symbolType}: {symbol}
    </p>
  );
};
